import { AxiosResponse } from 'axios';
import {
  BankHourRequest,
  BankHourRequestStatus,
} from '../models/bank-hours-request';
import { api } from '../providers/base-api';
import { PaginatedResponse } from '../utils/types/data/pagination';

export type GetBankHourRequestPaginatedQuery = {
  page: number;
  limit: number;
  userId?: number;
  status?: BankHourRequestStatus;
  supervisorId?: number;
};

export type ListBankHoursRequestQueryDto = {
  status?: BankHourRequestStatus;
  supervisorId?: number;
  userId?: number;
};

export type ApprovalBankHourRequestDto = {
  isApproved: boolean;
  supervisorNote?: string;
};

export type CreateBankHourRequestDto = {
  date: string;
  description?: string;
};

export type CreateBankHourRequestPartialDto = {
  date: string;
  begin: string;
  end: string;
  description?: string;
};

export async function createRequest(
  data: CreateBankHourRequestDto,
): Promise<AxiosResponse<void>> {
  const response = await api.post<void>('/bank-hour-request', data);

  return response;
}

export async function getBankHourRequestPaginatedRequest(
  params: GetBankHourRequestPaginatedQuery,
): Promise<AxiosResponse<PaginatedResponse<BankHourRequest>>> {
  const response = await api.get<PaginatedResponse<BankHourRequest>>(
    '/bank-hour-request/paginated',
    {
      params,
    },
  );

  return response;
}

export async function listBankHourRequests(): Promise<
  AxiosResponse<BankHourRequest[]>
> {
  const response = await api.get<BankHourRequest[]>(
    '/bank-hour-request/list-requests',
  );

  return response;
}

export async function listBankHourApprovalsRequest(
  params: ListBankHoursRequestQueryDto,
): Promise<AxiosResponse<BankHourRequest[]>> {
  const response = await api.get<BankHourRequest[]>(
    '/bank-hour-request/list-approvals',
    {
      params,
    },
  );

  return response;
}

export async function bankRequestApprovalRequest(
  requestId: number,
  data: ApprovalBankHourRequestDto,
): Promise<AxiosResponse<BankHourRequest>> {
  const response = await api.put<BankHourRequest>(
    `/bank-hour-request/approval/${requestId}`,
    data,
  );

  return response;
}

export async function createRequestPartial(
  data: CreateBankHourRequestPartialDto,
): Promise<AxiosResponse<void>> {
  const response = await api.post<void>('/bank-hour-request/partial', data);

  return response;
}

export async function cancelBankHourRequest(
  requestId: number,
): Promise<AxiosResponse<BankHourRequest>> {
  return api.put<BankHourRequest>(`/bank-hour-request/cancel/${requestId}`);
}
